import { Component, OnInit } from '@angular/core';
import { HelperService } from '../../helper/helper.service';
import { ProductService } from '../../helper/shop/product.service';
import { TranslatesService } from '../../helper/translate/translate.service';
import { TranslateService } from '@ngx-translate/core';
import { UniversalStorage } from '../../helper/storage/universal.storage';
import { ActivatedRoute, Router } from '@angular/router';
import { Title } from '@angular/platform-browser';
import { TypesService } from '../../data/types.service';
import { Type } from '../../interfaces/type';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.css']
})
export class HeaderComponent extends HelperService implements OnInit {
  public cartlength: number | undefined;
  activeTab: string = 'home';

  types: Type[] = [];
  activeTypeId: number | null = null;

  constructor(
    private productService: ProductService,
    public _translatesService: TranslatesService,
    private translate: TranslateService,
    private _storage: UniversalStorage,
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private titleService: Title,
    private _typesService: TypesService
  ) {
    super();
  }

  ngOnInit(): void {
    this.getTypes();

    let storedLang = this._storage.getItem('langCode');

    if (!storedLang) {
      const browserLang = navigator.language?.slice(0, 2);

      if (browserLang === 'ar' || browserLang === 'en') {
        storedLang = browserLang;
      } else {
        storedLang = 'en';
      }
    }

    this.changeLanguage(storedLang, false);

    this.cartlength = this.productService.getProductsCountInCart();
    this.productService.watchStorage().subscribe((data) => {
      this.cartlength = this.productService.getProductsCountInCart();
    });

    this.activatedRoute.queryParams.subscribe(params => {
      const lang = params['lang'];
      if (lang) {
        this.changeLanguage(lang, false);
      }
    });

    this.activatedRoute.queryParams.subscribe(params => {
      if (params['typeIds']?.length) {
        this.activeTypeId = +params['typeIds'][0];
      } else {
        this.activeTypeId = null;
      }
    });

    this.router.events.subscribe(() => {
      this.setActiveTab();
    });
    this.setActiveTab();

    this.translate.onLangChange.subscribe(() => {
      this.updateTabTitle();
    });

    this.translate.onLangChange.subscribe(() => {
      this.addTypesToNavigation();
    });
  }

  setActiveTab(): void {
    const currentRoute = this.activatedRoute.snapshot.firstChild?.url[0]?.path;
    this.activeTab = currentRoute || '';
  }

  changeLanguage(code: string, navigate: boolean = true): void {
    this._translatesService.changeLang(code);
    this.translate.use(code);
    this._storage.setItem('langCode', code);

    if (navigate) {
      this.router.navigate([], {
        relativeTo: this.activatedRoute,
        queryParams: { lang: code },
        queryParamsHandling: 'merge'
      });
    }
  }

  updateTabTitle(): void {
    const routeTitle = this.getRouteTitle(this.activatedRoute.snapshot.root);
    if (routeTitle) {
      this.translate.get(routeTitle).subscribe((translatedTitle: string) => {
        this.titleService.setTitle(translatedTitle);
      });
    }
  }

  getRouteTitle(route: any): string | null {
    if (route.data && route.data['title']) {
      return route.data['title'];
    }
    if (route.firstChild) {
      return this.getRouteTitle(route.firstChild);
    }
    return null;
  }

addTypesToNavigation() {
  if (!this.types?.length) return;

  const baseNavigation = [...this.navigation];

  const cleanNavigation = baseNavigation.filter(item => !item.isType);

  const typeNavItems = this.types.map(type => ({
    link: '/library',
    linkText: this.getTypeName(type),
    queryParams: {
      typeIds: [type.id],
      subTypeIds: type.sub_types?.map(st => st.id) || []
    },
    child: false,
    isType: true
  }));

  this.navigation = [
    cleanNavigation[0],
    ...typeNavItems,
    ...cleanNavigation.slice(1)
  ];
}

getTypes() {
  this._typesService.getTypes().subscribe((res: any) => {
    if (res) {

      this.types = res.types.filter((type: any) =>
        type.id !== 11 && type.id !== 12
      );

      this.addTypesToNavigation();
    }
  }, (error) => {
    console.error('TYPES ERROR:', error);
  });
}

getTypeName(type: Type): string {
  const isArabic = this._translatesService.getCurrentLang() === 'ar';

  return isArabic
    ? (type.name_ar || type.name)
    : (type.name || type.name_ar);
}

  getQueryParams(item: any) {
    return item.queryParams
      ? {
          ...item.queryParams,
          lang: this._translatesService.getCurrentLang()
        }
      : {
          lang: this._translatesService.getCurrentLang()
        };
  }

  isActive(item: any): boolean {
    if (!item.isType) {
      return item.link === '/' + this.activeTab;
    }

    return item.queryParams?.typeIds?.[0] === this.activeTypeId;
  }
}
